import React from 'react';
import ReactDOM from 'react-dom/client';

import SubscribeForm from './SubscribeForm';

const subscribeDiv = document.getElementById('subscribe-form');
const subscribeInPageDiv = document.getElementById('subscribe-form-in-page');

if (subscribeDiv !== null) {
  const selectDiv = ReactDOM.createRoot(subscribeDiv);
  selectDiv.render(
    <>
      <SubscribeForm />
    </>
  );  
} else if (subscribeInPageDiv !== null) {
  const selectDiv = ReactDOM.createRoot(subscribeInPageDiv);
  selectDiv.render(
    <>
      <SubscribeForm initialDisplayLists={true} displayH3={false} />
    </>
  );  
}